"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RugbyUnionAdAllocationEvent;
(function (RugbyUnionAdAllocationEvent) {
    RugbyUnionAdAllocationEvent["try"] = "try";
    RugbyUnionAdAllocationEvent["dropGoal"] = "dropGoal";
    RugbyUnionAdAllocationEvent["conversion"] = "conversion";
    RugbyUnionAdAllocationEvent["penaltyGoal"] = "penaltyGoal";
    RugbyUnionAdAllocationEvent["redCard"] = "redCard";
    RugbyUnionAdAllocationEvent["yellowCard"] = "yellowCard";
    RugbyUnionAdAllocationEvent["penaltyConceded"] = "penaltyConceded";
})(RugbyUnionAdAllocationEvent = exports.RugbyUnionAdAllocationEvent || (exports.RugbyUnionAdAllocationEvent = {}));
//# sourceMappingURL=adEvents.js.map